import { createContext, useContext } from "react";
import { FunctionSubscriberValue } from "./FunctionSubscriberProvider";

// Default is intentionally {} (not a full FunctionSubscriberValue) for components rendered without a
// FunctionSubscriberProvider ancestor (tests, forgotten wiring). Consumers must keep guarding individual
// functions before calling them (e.g. RuntimePlayback's `if (functionSubscriber.plexGetTraceEntries)`) —
// don't remove those checks just because FunctionSubscriberProvider now always builds every function.
export const FunctionSubscriberContext = createContext<Partial<FunctionSubscriberValue>>({});

export const useFunctionSubscriber = () => {
  return useContext(FunctionSubscriberContext);
};
